import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useStorage64 } from './useStorageBase64';
import { getCardData, getCardList } from 'services/Cards';
import { getVerificarCreditoCS, postVerificaAceptacionCredito } from 'services/verificarCreditoCS';
import { useToken } from 'pages/Header/Content/hooks/useToken'

export function useVerificarCredito(incode) {

    // console.log('incode useVerificarCredito', incode)
    const history = useHistory()

    const session_token = decodeStorage('session_token')
    const access_token = decodeStorage('access_token')
    const [sears_numero_internet, setSearsNumInternet] = useStorage64('sears_numero_internet', "")
    const [cardending, setCardendigin] = useStorage64('cardending', "")
    const [montoCredito, setmontoCredito] = useStorage64("montoCredito", "")
    const [creditoDisponible, setCreditoDisponible] = useStorage64("creditoDisponible", "")
    
    // Almacena respuesta de peticion a servicios
    const [respuestaGetListCS, setRespuestaGetListCs] = useState(false)
    const [responseVerificarCreditoCs, setResponseVerificarCreditoCs] = useState()
    const [respuestaGetCardData, setRespuestaGetCardData] = useState(false)
    const [aceptar, setAceptar] = useState(false)

    const [associatedCards, setAssociatedCards] = useState(false)
    const [cardsService, setCardsService] = useState(false)
    
    // Banderas
    const [fechaConsulta, , setfechaconsulta] = useStorage64("fechaManana", "")
    const [estadoCredito, setEstadoCredito] = useStorage64("estadoCredito", "")
    const [pasarAverificar, setPasarAverificar] = useState(false)
    const [loading, setLoading] = useState(true)
    const [errorCode, setErrorCode] = useState()
    const [idClaro, setIdClaro] = useStorage64('profileData', '')
    const profileData = decodeStorage('profileData')
    
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState("")
    const [showModalErr, setShowModalErr] = useState(false)

    // Variable para determinar si optuvo cardending
    const [cardendingRes, setCardendingRes] = useState(false)
    const firstSessionGCL = window.sessionStorage.getItem('firstSessionGCL')
    

    /*  --------------------------- Inicio --------------------------------------  */
    const timeToken = useToken({ firstActive: false, name: "verifica credito", timeRef: 1000 })
    const [actionOK, setActionOk] = useState(false)
        useEffect(() => {
            setTimeout(function(){
                setActionOk('ready')
            },700)
        }, [])
    /*  --------------------------- Inicio Peticiones --------------------------------------  */
        //  Ajusta Los tiempos y refresca token
        const [serviceRT, setServiceRT] = useState(false)
        useEffect(()=>{
            if(actionOK){
                let  actTimeLS = Date.now()
                let  atExpLS = decodeStorage('access_token_exp') * 1000
                   
                if(actTimeLS <= atExpLS || Date.now() <= (decodeStorage('access_token_exp') * 1000) ){
                    setServiceRT(true)
                }
                else{
                    timeToken.forceToken(true)
                }
            }
        },[timeToken.newToken, actionOK])
    /*  --------------------------- Fin --------------------------------------  */


    useEffect(() => {
        // Envia peticion para obtener get list
        if(serviceRT){
            if (session_token && String(session_token).length > 1) {

                if(decodeStorage('associatedCards') ){
                    if(!firstSessionGCL){
                        getCardList()
                        .then(setRespuestaGetListCs)
                        window.sessionStorage.setItem('firstSessionGCL', true)
                        setLoading(true)
                    }else{
                        setPasarAverificar(true)
                        setLoading(true)
                    }
                }else{
                    getCardList()
                    .then(setRespuestaGetListCs)
                    setLoading(true)
                }
            }
        }
    }, [session_token, serviceRT])


    useEffect(() => {
        // Revisar que usuario ya acepto el credito
        // console.log('respuestaGetListCS', respuestaGetListCS)
        if (respuestaGetListCS) {

            if (respuestaGetListCS && respuestaGetListCS?.data && String(respuestaGetListCS?.data?.codMen) === "200") {
                setAssociatedCards(respuestaGetListCS?.data)
                encodeStorage('associatedCards', respuestaGetListCS?.data)
                encodeStorage("sears_numero_internet", respuestaGetListCS?.data?.noInternet)
                encodeStorage("cardending", respuestaGetListCS?.data?.cta_nva.substr(-4))
                setSearsNumInternet(respuestaGetListCS?.data?.noInternet)
                setCardendigin(respuestaGetListCS?.data?.cta_nva.substr(-4))
                encodeStorage("fechaManana", Date.now() + 86400000)
                setfechaconsulta(Date.now() + 86400000)
                setPasarAverificar(true)
                setCardendingRes(true)
            }

            else if (respuestaGetListCS?.statusCode === 400) {
                // history.push(`${BASE_PATH}${SUB_DIRECTORY}beneficios`);
                // console.log('ahora vamos por esta parte')
                setCardendingRes(true);
                if (JSON.parse(respuestaGetListCS?.data)?.codMen.includes("ERR003")) {
                        if(incode){
                            console.log('pasa por incode')
                        }else{
                            history.push(`${BASE_PATH}${SUB_DIRECTORY}beneficios`);
                            setLoading(true);
                        }
                }
                else if (JSON.parse(respuestaGetListCS?.data)?.codMen.includes("ERR00") && !JSON.parse(respuestaGetListCS?.data)?.codMen.includes("ERR003")) {             
                    setShowModalErr(true)
                    setErrorCode(respuestaGetListCS?.statusCode)
                    setSectionActive('consultar')
                    setMessageResponse(JSON.parse(respuestaGetListCS.data).codMen)
                    removeStorage('associatedCards')
                    setLoading(false);
                }
            }

            else if (respuestaGetListCS?.statusCode === 404) {
                setShowModalErr(true)
                setErrorCode(respuestaGetListCS?.statusCode)
                setSectionActive('consultar')
                setMessageResponse(JSON.parse(respuestaGetListCS.data).codMen)
                setLoading(false)
                setCardendingRes(true)
            }

            else if (respuestaGetListCS?.statusCode >= 500) {
                setErrorCode(500)
                setLoading(false)
                setCardendingRes(true)
            }
        }
    }, [respuestaGetListCS])


    useEffect(() => {
        if (pasarAverificar) {
            getVerificarCreditoCS(session_token)
            .then(setResponseVerificarCreditoCs)
            setLoading(true);
        }
    }, [pasarAverificar])


    // Revisar que usuario tenga credito
    useEffect(() => {
        if (responseVerificarCreditoCs) {
            // console.log('responseVerificarCreditoCs: ', responseVerificarCreditoCs)
            if ((responseVerificarCreditoCs && (responseVerificarCreditoCs?.data?.metadata?.http_status === 200 || JSON.parse(responseVerificarCreditoCs?.data)?.metadata?.http_status === 200) )
            ){
                // Tiene credito  autorizado / pre autorizado
                setEstadoCredito(200)
                getCardData(sears_numero_internet, cardending)
                .then(setRespuestaGetCardData)
                setLoading(true)
            }
            else if (responseVerificarCreditoCs && (responseVerificarCreditoCs?.data?.metadata?.http_status === 404 || JSON.parse(responseVerificarCreditoCs?.data)?.metadata?.http_status === 404)){
                // No tiene credito aceptado
                setEstadoCredito(404)
                getCardData(sears_numero_internet, cardending)
                .then(setRespuestaGetCardData);
                setLoading(true)
            } 
            else if (responseVerificarCreditoCs && (responseVerificarCreditoCs?.data?.metadata?.http_status === 401 || JSON.parse(responseVerificarCreditoCs?.data)?.metadata?.http_status === 401)){
                // No tiene sesion / token incorrecto
                setEstadoCredito(401)
                setLoading(false)
            }
            else if (responseVerificarCreditoCs && (responseVerificarCreditoCs?.data?.metadata?.http_status === 409 || JSON.parse(responseVerificarCreditoCs?.data)?.metadata?.http_status === 409)){
                // Sin telefono 
                setEstadoCredito(409)
                getCardData(sears_numero_internet, cardending)
                .then(setRespuestaGetCardData);
                setLoading(true)
            }
            else if (responseVerificarCreditoCs && (responseVerificarCreditoCs?.data?.metadata?.http_status === 412 || JSON.parse(responseVerificarCreditoCs?.data)?.metadata?.http_status === 412)){
                // Telefono no validado 
                setEstadoCredito(412)
                getCardData(sears_numero_internet, cardending)
                .then(setRespuestaGetCardData);
                setLoading(true)
            }
            else if (responseVerificarCreditoCs && JSON.parse(responseVerificarCreditoCs.data)?.metadata?.http_status >= 500){
                setErrorCode(responseVerificarCreditoCs.data?.metadata?.http_status);
            }
            else{
                setErrorCode(500);
                setLoading(false);
            }
            setPasarAverificar(false);
        }
    }, [responseVerificarCreditoCs])


    useEffect(() => {
        // Guarda los valores de monto credito autorizado / credito disponible
        if (respuestaGetCardData && respuestaGetCardData.data && respuestaGetCardData?.statusCode !== 400) {
            // Actualiza monto credito en el storage
            setCardsService(respuestaGetCardData?.data)
            encodeStorage("montoCredito", respuestaGetCardData?.data[0]?.credit_imit);
            encodeStorage("creditoDisponible", respuestaGetCardData?.data[0]?.credit_available);
            setmontoCredito(respuestaGetCardData?.data[0]?.credit_imit);
            setCreditoDisponible(respuestaGetCardData?.data[0]?.credit_available);
            setLoading(false);
        }
        else if (respuestaGetCardData?.statusCode === 400) {
            setShowModalErr(true);
            setErrorCode(respuestaGetCardData?.statusCode);
            setSectionActive('consultar');
            setMessageResponse(JSON.parse(respuestaGetCardData.data).codMen);
            setLoading(false);
        }
        else if (respuestaGetCardData && respuestaGetCardData.data?.codMen === 500) {
            setErrorCode(500);
        }

    }, [respuestaGetCardData])


    function aceptarCredito() {
        // Acepta credito claroshop pre autorizado
        setLoading(true);
        history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/autorizar`)
    }


    useEffect(() => {
        // Redirecciona al aceptar credito claroshop
        if (aceptar) {
            if (aceptar?.statusCode === 201) {
                // Acepta el credito por primera vez
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`)
            }
            else if (aceptar?.statusCode === 409) {
                // Ya habia aceptado el credito antes
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`)
            }
            else if (aceptar?.statusCode === 401) {
                // No se pudo aceptar el credito / no hay sesion
                window.location.replace(`${BASE_PATH}login?redirect=${window.location.href}`)
            }
            else if (aceptar?.statusCode >= 500) {
                // No se pudo aceptar el credito / ocurrio un error
                setErrorCode(aceptar?.statusCode)
            }
            setLoading(false);
        }
    }, [aceptar])


    return {
        loading,
        session_token,
        cardending,
        sears_numero_internet,
        aceptarCredito,
        montoCredito,
        creditoDisponible,
        estadoCredito,
        errorCode,
        setErrorCode,
        showModalErr,
        sectionActive,
        setShowModalErr,
        messageResponse,
        cardendingRes,

        associatedCards,
        cardsService
    }
}